// extracted by mini-css-extract-plugin
module.exports = {"highlight":"DrugCosts_highlight__2GgEp","total":"DrugCosts_total__9rT_o","table":"DrugCosts_table__3T87N","tables":"DrugCosts_tables__1NrrG"};